// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorFallback_wrapper__QNEA6","title":"ErrorFallback_title__pMCRo","message":"ErrorFallback_message__dADsu","retryButton":"ErrorFallback_retryButton__V-Pbq"};